import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'primereact/tooltip';
import { COMMON_TEXT } from '@/helpers/common-text';
import { createAuthenticatedApiClient } from '@/helpers/api-client';
import { EmployeelocationsApi } from 'src/openapi';
import './FollowButton.less';

class FollowButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFollowing: props.isFollowing || false,
      isLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFollowing !== this.props.isFollowing) {
      this.setState({ isFollowing: this.props.isFollowing });
    }
  }

  handleToggleFollow = async (e) => {
    e.stopPropagation(); // Prevent triggering parent click events

    const { employeeId, onFollowChange, showToast } = this.props;
    const { isFollowing } = this.state;

    if (!employeeId) {
      console.error('Employee ID is required');
      return;
    }

    this.setState({ isLoading: true });

    try {
      const employeeLocationsApi = createAuthenticatedApiClient(EmployeelocationsApi);

      if (isFollowing) {
        // Unfollow
        await employeeLocationsApi.unfollowEmployee({ employeeId: parseInt(employeeId) });

        this.setState({ isFollowing: false });

        if (showToast) {
          showToast({
            severity: 'success',
            summary: COMMON_TEXT.UNFOLLOWED_SUCCESS,
            life: 3000,
          });
        }

        if (onFollowChange) {
          onFollowChange(employeeId, false);
        }
      } else {
        // Follow
        await employeeLocationsApi.followEmployees({
          apiEmployeeLocationFollowsRequest: {
            employeeIds: [parseInt(employeeId)],
          },
        });

        this.setState({ isFollowing: true });

        if (showToast) {
          showToast({
            severity: 'success',
            summary: COMMON_TEXT.FOLLOWED_SUCCESS,
            life: 3000,
          });
        }

        if (onFollowChange) {
          onFollowChange(employeeId, true);
        }
      }
    } catch (error) {
      console.error('Error toggling follow status:', error);

      if (showToast) {
        showToast({
          severity: 'error',
          summary: 'エラーが発生しました',
          detail: 'フォロー状態の変更に失敗しました',
          life: 3000,
        });
      }
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isFollowing, isLoading } = this.state;
    const { className, employeeId } = this.props;

    const tooltipText = isFollowing ? COMMON_TEXT.UNFOLLOW : COMMON_TEXT.FOLLOW;
    const uniqueClass = `follow-button-${employeeId}`;

    return (
      <>
        <Tooltip
          target={`.${uniqueClass}`}
          content={tooltipText}
          position="top"
          showDelay={300}
          hideDelay={0}
        />
        <div
          className={`follow-button ${uniqueClass} ${className || ''} ${isFollowing ? 'following' : ''} ${isLoading ? 'loading' : ''}`}
          onClick={this.handleToggleFollow}
        >
          <i className={`pi ${isFollowing ? 'pi-star-fill' : 'pi-star'}`} />
        </div>
      </>
    );
  }
}

FollowButton.propTypes = {
  employeeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isFollowing: PropTypes.bool,
  onFollowChange: PropTypes.func,
  showToast: PropTypes.func,
  className: PropTypes.string,
};

FollowButton.defaultProps = {
  isFollowing: false,
  onFollowChange: null,
  showToast: null,
  className: '',
};

export default FollowButton;
